import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../../../config/constants';

type MessageResponse = {
  title: string;
  description: string | null;
};

export default function MessageBox() {
  const [message, setMessage] = useState<MessageResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const response = await fetch(`${apiUrl}/message/companyMessage`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data: MessageResponse | null = await response.json();

        if (!data) {
          setMessage(null);
          return;
        }

        setMessage(data);
      } catch (err) {
        console.error('Failed to load company message', err);
        setMessage(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMessage();
  }, []);

  if (loading) {
    return null;
  }

  if (!message) {
    return null;
  }

  return (
    <div className="text-box">
      <h3 className="text-box__title">{message.title}</h3>
      {message.description && (
        <p className="text-box__description">{message.description}</p>
      )}
    </div>
  );
}